module.exports = __webpack_public_path__ + "static/media/communitylifeicon-2.bb132438.png";